import type { CostServiceAttachmentView } from './views.js';

/**
 * A link has ended once its last day is before `today` (`YYYY-MM-DD`, the same calendar the API
 * uses). A link with no end date, or one that ends today, is still live.
 */
export function isCostServiceAttachmentEnded(
  attachment: Pick<CostServiceAttachmentView, 'activeTo'>,
  today: string,
): boolean {
  return attachment.activeTo !== null && attachment.activeTo < today;
}

/**
 * The links that keep the base type of a Cost Service from changing: live links that carry a
 * rate override. An override is written in the form of the current base type (`12.5%` or
 * `1200.00`), so switching the type under a live one would change what it means. Ended links keep
 * their history and no longer lock. The API refuses the change with
 * `COST_SERVICE_BASE_TYPE_LOCKED` and the screen disables the control from the same answer.
 */
export function costServiceBaseTypeLockedBy<
  T extends Pick<CostServiceAttachmentView, 'rateOverride' | 'activeTo'>,
>(attachments: readonly T[], today: string): T[] {
  return attachments.filter(
    (attachment) =>
      attachment.rateOverride !== null && !isCostServiceAttachmentEnded(attachment, today),
  );
}
